




































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import _isNil from "lodash/isNil";
import QErrors from "@/common/qErrors.vue";
import mDeliveryDestination from "@/model/mDeliveryDestination";
import qNotify from "@/common/qNotify";
import postalCode from "@/components/common/postalCode.vue";
import qInput from "@/components/common/qInput.vue";
@Component({
  name: "DeliveryDestinationEditPopUp",
  components: {
    QErrors,
    postalCode,
    qInput
  },
})
export default class DeliveryDestinationEditPopUp extends Vue {
  public isShow = false;
  public delivery: mDeliveryDestination = new mDeliveryDestination();
  public isAdd = true;
  public errors = {};
  public title: any = "";

  @Watch('delivery.postal_code')
  changePostalCode() {
    if (this.delivery.postal_code.length < 7) {
      this.delivery.prefectures_name = '';
      this.delivery.prefectures_code = '';
    }
  }

  public onChangePostalCode(address) {
    this.delivery.address_1 = address.city_name;
    this.delivery.prefectures_name = address.pref_name;
    this.delivery.prefectures_code = address.prefecture_code;
  }
  public async show(delivery) {
    this.errors = {};
    this.title = this.$t("my_page.delivery_destination.title");
    if (!_isNil(delivery)) {
      this.isAdd = false;
      this.delivery = new mDeliveryDestination(delivery);
      this.title = delivery.dlv_dst_name + "の修正"
      this.isShow = true;
      return;
    }
    this.isAdd = true;
    this.isShow = true;
    this.delivery = new mDeliveryDestination();
  }
  public async submit() {
    let result = null;
    if (!this.isAdd) {
      result = await this.delivery.update();
    } else {
      result = await this.delivery.add();
    }

    if (result.meta.status != "200") {
      this.errors = result.meta.errors;
      qNotify.error({
        text: result.meta.message,
      });
      return;
    } else {
      qNotify.success({
        text: result.meta.message,
      });
      
      this.$emit("reloadData");
    }

    this.isShow = false;
  }
  public cancel() {
    this.isShow = false;
  }
  public remove() {
    this.$modal.showDelete({
      confirmClass: "mb__add-color-red",
      text: `${this.delivery.dlv_dst_name}${this.$t(
        "my_page.delivery_destination.delete_message"
      )}`,
      // we are passing callback method for our confirm button
      onConfirm: () => {
        this.delivery.delete().then(
          (response: any) => {
            this.cancel();
            this.$emit("save", {});
            qNotify.success({
              text: response.meta.message,
            });
          },
          (error) => {
            qNotify.error({
              text: error.meta.message,
            });
          }
        );
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }
}
